import * as T3_Ajax from 'T3_AJAX';

const selector_form = '.vd-form.vd-form--survey-contact';

const events = () => {
  $(document).ready(function () {
    $(
      selector_form + ' .form-group--Text input, ' + selector_form + ' .form-group--Select select'
    ).each(function () {
      if ($(this).val() !== '') {
        $(this).next('label').addClass('status status--visible');
      } else {
        $(this).next('label').removeClass('status--visible');
      }
    });
  });

  $(selector_form + ' .form-group--Text input').on('input', function () {
    if ($(this).val() !== '') {
      $(this).next('label').addClass('status status--visible');
    } else {
      $(this).next('label').removeClass('status--visible');
    }
    validate();
  });

  $(
    selector_form +
      ' .form-group > select, ' +
      selector_form +
      ' .form-group .form-group__input > select'
  ).on('change', function () {
    if ($(this).val() !== '') {
      $(this).next('label').addClass('status status--visible');
    } else {
      $(this).next('label').removeClass('status--visible');
    }
    validate();
  });
};

const actions = () => {
  //init
  $(selector_form + ' .form-group--Select,' + selector_form + ' .form-group--Default').each(
    function () {
      let parent;
      if (!$(this).hasClass('form-group--district')) {
        parent = $(this);
      } else {
        parent = $(this).find('.form-group__input');
      }

      parent.each(function () {
        if ($(this).find('select').val() !== '') {
          $(this)
            .find('select')
            .siblings('.label')
            .text($(this).find('select option:selected').text());
          $(this).attr('data-selected', '1');
        }

        if ($(this).find('select').prop('disabled') === true) {
          $(this).find('select').siblings('.label').addClass('label--disabled');
        }
      });
    }
  );

  $(document).on('click', selector_form + ' .form-group .label', function () {
    if (!$(this).hasClass('label--disabled')) {
      $(this).parents('.vd-form').find('ul').hide(0);
      $(this).parents('.vd-form').find('ul').siblings('.label').show(0);
      $(this).hide(0).siblings('ul').show(0);
      $('body').addClass('select-field-open');
    }
  });

  $(document).on('click', selector_form + ' input[type="checkbox"]', function () {
    validate();
  });

  $(document).on('click', 'body.select-field-open *', function () {
    if (!$(this).is('li')) {
      $('.form-group ul').hide(0).siblings('.label').show(0);
      $('body').removeClass('select-field-open');
    }
  });

  $(document).on('click', selector_form + ' .form-group ul li', function () {
    $(this).parent().siblings('select').val($(this).attr('data-value')).trigger('change');

    $(this).parent().hide(0).siblings('.label').show(0);

    if ($(this).attr('data-value') !== '') {
      $(this).parents('.form-group').attr('data-selected', '1');
    } else {
      $(this).parents('.form-group').attr('data-selected', '0');
    }

    if (
      $(this).parents('.form-group').hasClass('form-group--district') &&
      $(this).parents('ul').attr('data-select-for') === 'country'
    ) {
      let selectedCountry = $(this).attr('data-value');

      $(this)
        .parents('.form-group')
        .find('ul[data-select-for="district"] li')
        .each(function () {
          if ($(this).attr('data-country') === selectedCountry) {
            $(this).show(0);
          } else {
            $(this).hide(0);
          }
        });

      let ulDistrict = $(this).parents('.form-group').find('ul[data-select-for="district"]');

      if (selectedCountry === '') {
        ulDistrict
          .siblings('.label')
          .text(ulDistrict.siblings('.label').attr('data-label-default'))
          .addClass('label--disabled');
        ulDistrict.siblings('select').prop('disabled', false).val('');
        $(this).parents('.form-group').attr('data-selected', '0');
      } else {
        ulDistrict
          .siblings('.label')
          .removeClass('label--disabled')
          .text(ulDistrict.siblings('.label').attr('data-label-default'));
      }
      switchButtonStatus('disable');
    }
  });

  $(
    selector_form +
      ' .form-group > select, ' +
      selector_form +
      ' .form-group .form-group__input > select'
  ).on('change', function () {
    let labelText = $(this).find('option:selected').text();
    if (labelText === '') {
      labelText = $(this).siblings('.label').attr('data-label-default');
    }

    $(this).siblings('.label').text(labelText);

    if (
      $(this).parents('.form-group').hasClass('form-group--district') &&
      $(this).attr('name') === 'country'
    ) {
      let country = $(this).val();
      $(this)
        .parents('.form-group')
        .find('select[name="district"] option')
        .each(function () {
          if ($(this).attr('data-country') === country) {
            $(this).show(0);
          } else {
            $(this).hide(0);
          }
        });
    } else {
      if ($(this).val() === '') {
        $(this).parents('.form-group').find('label').hide(0);
      } else {
        $(this).parents('.form-group').find('label').show(0);
      }
    }
  });

  //click next button
  $(document).on(
    'click',
    selector_form + ' .vd-form__actions .vd-btn.vd-btn--next[data-action="complete"]',
    function (e) {
      e.preventDefault();
      if (!$(this).hasClass('status--disabled')) {
        //TODO: save data

        complete($(this));
      }
    }
  );
};

const complete = (_caller) => {
  const form = _caller.parents('form');
  const stepActual = form.attr('data-actual-step');
  const stepsOverall = form.attr('data-steps-overall');
  const token = form.attr('data-token');

  let params = {
    action: 'complete',
    controller: 'Ajax',
    extension: 'tx_vdsurveys',
    typeNum: 787839,
    formData: fetchFormData(form),
  };

  T3_Ajax.call(
    params,
    _caller,
    function () {},
    function () {
      window.location.href = _caller.attr('href');
    }
  );
};

const fetchFormData = (_form) => {
  let values = {};

  _form.find('input[type="text"],select').each(function () {
    values[$(this).attr('id')] = $(this).val();
  });

  let serialized = JSON.stringify(values);
  return serialized;
};

const validate = () => {
  const _form = $(selector_form);
  const inputElements = $(selector_form + ' input,' + selector_form + ' select');

  const nor = _form.find('.form-group[data-required="1"]').length;
  console.log(_form.find('.form-group[data-required="1"]'));
  console.log('number of input elements: ' + nor);
  //init
  const fullfilled = check();
  console.log('fullfilled: ' + fullfilled);
  if (nor === fullfilled) {
    switchButtonStatus('enable');
  } else {
    switchButtonStatus('disable');
  }

  inputElements.on('input change', function () {
    const fullfilled = check();

    if (nor === fullfilled) {
      switchButtonStatus('enable');
    } else {
      switchButtonStatus('disable');
    }
  });
};

const check = () => {
  let fullfilled = 0;

  $(selector_form + ' .form-group[data-required="1"]').each(function () {
    let input = $(this).find('input');
    let select = $(this).find('select');

    let success = true;

    if (input.length > 0) {
      const type = input.attr('type');

      if (type === 'text') {
        if (input.val() === '' || input.val().length < 3) {
          success = false;
        }
      }

      if (type === 'email') {
        if (input.val() === '' || !validateEmail(input.val())) {
          success = false;
        }
      }

      if (type === 'checkbox') {
        if (!input.prop('checked')) {
          success = false;
        }
      }
    }

    if (select.length > 0) {
      select.each(function () {
        if (success) {
          if ($(this).val() === '') {
            success = false;
          }
        }
      });
    }

    if (success) {
      fullfilled++;
    }
  });

  return fullfilled;
};

const switchButtonStatus = (status) => {
  const _form = $(selector_form);
  const _button = _form.find('.vd-form__actions .vd-btn.vd-btn--next');

  if (status === 'enable') {
    _button.removeClass('status--disabled').addClass('status status--enabled');
  }
  if (status === 'disable') {
    _button.removeClass('status--enabled').addClass('status status--disabled');
  }
};

const init = () => {
  buildSelectList();
};

const buildSelectList = () => {
  $('.form-group > select, .form-group__input > select').each(function () {
    let container = $(this).parent();

    let selectList = '<ul data-select-for="' + $(this).attr('name') + '">';

    $(this)
      .find('option')
      .each(function () {
        let additionalAttributes = '';

        if (typeof $(this).attr('data-country') !== 'undefined') {
          additionalAttributes = additionalAttributes.concat(
            ' data-country="' + $(this).attr('data-country') + '"'
          );
        }

        selectList +=
          '<li data-value="' +
          $(this).val() +
          '"' +
          additionalAttributes +
          '>' +
          $(this).text() +
          '</li>';
      });

    selectList += '</ul>';

    $(this).hide(0);
    container.prepend(selectList);
    container.find('ul li').show();
    if ($(this).find('option').first().val() === '') {
      //container.find('ul li').first().hide();
    }
  });
};

const validateEmail = (email) => {
  const re =
    /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

/**
 * export methods
 */

export { actions, events, init, switchButtonStatus, validate };
